const INTL_MODULE_PROVIDERS = [];

export {INTL_MODULE_PROVIDERS};
